import { AxiosError } from 'axios'
import {
  type QueryFunctionContext,
  type QueryObserverOptions,
  useQuery
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { failureFlagsQueryKeys } from 'queries/failure-flags/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

import type { FailureFlagApplication } from 'types/api/failure-flags/failure-flags'

function fetchFailureFlagsApp({
  queryKey: [endpoint, params]
}: QueryFunctionContext<ReturnType<typeof failureFlagsQueryKeys.getApp>>) {
  if (!endpoint) {
    throw new AxiosError('No failure flag app name was provided to query')
  }

  const endpointWithParams = getEndpointWithParams(endpoint, params)

  return fetchQueryData<FailureFlagApplication>(endpointWithParams, {})
}

export function useGetFailureFlagsApp(
  name: string | undefined,
  options?: QueryObserverOptions<FailureFlagApplication, AxiosError>
) {
  const { currentTeamId } = useAuth()

  return useQuery<FailureFlagApplication, AxiosError>({
    ...options,
    ...(name && {
      queryKey: failureFlagsQueryKeys.getApp(name, currentTeamId)
    }),
    queryFn: fetchFailureFlagsApp
  })
}
